import { updateDocumentSuccess, updateDocumentFailure, UPDATE_DOCUMENT_REQUEST } from 'Redux/Action';
import { ofType }                                                                                         from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function updateDocumentEpic(action$, store$, { DocumentRepository }) {
    return action$.pipe(
        ofType(UPDATE_DOCUMENT_REQUEST),
        mergeMap( action =>{
            return from(
                DocumentRepository.update( action.payload.id, action.payload.formData )
                    .then(document => updateDocumentSuccess(document))
                    .catch(error => updateDocumentFailure(error)),
            );
        }),
    );
}
